import { Box, Typography, Button, Stack } from '@mui/material';
import { CheckCircle, Add, Dashboard } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

function Step4Conclusao({ concurso, idioma }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const nomeConcurso = concurso?.nome ?? 'o concurso';

  const handleNavigate = (path) => {
    // Normaliza idioma para formato curto ('pt-BR' → 'pt') — mesmo formato usado pela navbar
    if (idioma) {
      const lang = idioma.split('-')[0].toLowerCase();
      i18n.changeLanguage(lang);
    }
    navigate(path);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        py: 4,
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 88,
          height: 88,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'success.main',
          bgcolor: 'rgba(46, 125, 50, 0.1)',
        }}
      >
        <CheckCircle sx={{ fontSize: 48 }} />
      </Box>

      <Typography variant="h5">{t('wizard.step4.title')}</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        <Trans i18nKey="wizard.step4.subtitle" values={{ nomeConcurso }} components={{ b: <b /> }} />
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 2, width: '100%', maxWidth: 440 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<Add />}
          fullWidth
          onClick={() => handleNavigate('/inscricoes/novo')}
        >
          {t('wizard.step4.inscreverproduto')}
        </Button>
        <Button
          variant="outlined"
          size="large"
          startIcon={<Dashboard />}
          fullWidth
          onClick={() => handleNavigate('/dashboard')}
        >
          {t('wizard.step4.irpainel')}
        </Button>
      </Stack>
    </Box>
  );
}

export default Step4Conclusao;
